import { vuexModuleNames } from '..'
import { Auth } from '../../firebase'
import { ROLES } from "../../consts"
import { SET } from "vuelpers/lib/vuex"
import { createGetters, createMutations } from "vuelpers"

const initialState = () => ({
	isLoggedIn: false,
	currentUser: null
});

const hasRoles = (role) => state => {
	if (!state.currentUser) return
	return role === state.currentUser.role
}

const state = initialState();
const mutations = createMutations(SET);
const getters = createGetters(
	"isLoggedIn",
	"currentUser", {
	'isAdmin': hasRoles(ROLES.ADMIN),
	'isClient': hasRoles(ROLES.CLIENT),
	'isExpertAdmin': hasRoles(ROLES.EXPERT_ADMIN),
	'isExpertClient': hasRoles(ROLES.EXPERT_CLIENT),
})

const actions = {
	async logout({ dispatch }) {
		Auth.signOut().then(() => {
			dispatch('resetStates')
		})
	},
	resetStates({ dispatch }) {
		vuexModuleNames.forEach(module => {
			dispatch(
				`${module}/resetState`, null, {
				root: true
			})
		})
	},
	resetState({ commit }) {
		commit("SET", initialState());
	}
};

export default {
	state,
	actions,
	getters,
	mutations,
	namespaced: true
};
